import axios from 'axios'
import https from 'https'

const instance = axios.create({
  // .. where we make our configurations
  // eslint-disable-next-line no-undef
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  // Disable SSL verification for local development with self-signed certificates
  // eslint-disable-next-line no-undef
  httpsAgent:
    // eslint-disable-next-line no-undef
    process.env.NEXT_PUBLIC_API_URL &&
    // eslint-disable-next-line no-undef
    process.env.NEXT_PUBLIC_API_URL.includes('.test')
      ? new https.Agent({ rejectUnauthorized: false })
      : undefined
})
instance.defaults.headers.common[
  'Authorization'
  // eslint-disable-next-line no-undef
] = `Bearer ${process.env.NEXT_PUBLIC_API_AUTH_TOKEN}`
instance.defaults.headers.common['Accept'] = 'application/json'

export default instance
